import { alpha, type Theme } from "@mui/material/styles";
import type { FlowNodeKind } from "./types";

export function kindAccent(theme: Theme, kind: FlowNodeKind): string {
  const { palette } = theme;
  switch (kind) {
    case "source":
      return palette.info.main;
    case "process":
      return palette.primary.main;
    case "decision":
      return palette.warning.main;
    case "chat":
      return palette.primary.dark;
    case "tool":
      return palette.success.main;
    case "result":
      return palette.success.dark;
    case "store":
      return palette.info.dark;
    case "branch":
      return palette.text.secondary;
    default:
      return palette.primary.main;
  }
}

export function kindSurface(theme: Theme, kind: FlowNodeKind, active: boolean): string {
  const accent = kindAccent(theme, kind);
  const intensity =
    theme.palette.mode === "dark"
      ? active
        ? 0.28
        : 0.1
      : active
        ? 0.14
        : 0.05;
  return alpha(accent, intensity);
}

export function iconForKind(kind: FlowNodeKind): string {
  switch (kind) {
    case "source":
      return "dns";
    case "process":
      return "settings_suggest";
    case "decision":
      return "call_split";
    case "chat":
      return "forum";
    case "tool":
      return "build_circle";
    case "result":
      return "check_circle";
    case "store":
      return "hub";
    case "branch":
      return "subdirectory_arrow_right";
    default:
      return "circle";
  }
}
